import React, { Component, PropTypes } from 'react';
import TaskFeedback from './TaskFeedback';
import * as Icons from 'components/Material/SvgIcons';
import ProfileImage from 'components/Widgets/ProfileImage';
import { Shadow, Colors, Units } from 'Css';

const css = oxygenCss({
  root: {
    boxShadow: Shadow[1],
    backgroundColor: Colors.theme.Light.card,
    padding: Units.base,
    margin: Units.base
  },
  userName: {
    marginLeft: Units.base,
    fontSize: 24,
    display: 'inline-block'
  }
});

export default class CheckBoxTaskResult extends Component {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  render() {
    let { body, choices, user, correctResponse, created } = this.props;
    let { value } = body;
    let response;
    let correctAnswers = (correctResponse && correctResponse.value) || [];
    const neededValue = value.filter(val => correctAnswers.indexOf(val) === -1);
    if (correctAnswers && correctAnswers.length > 0) {
      let answers = [];
      correctAnswers.forEach(correctAnswer => {
        let label = choices[correctAnswer];
        let color;
        let icon;
        if (value.indexOf(correctAnswer) > -1) {
          color = Colors.material.green[500].hex;
          icon = <Icons.NavigationCheck style={{ verticalAlign: 'middle' }} />;
          answers.push([{text: ' - ' + label}, color, icon]);
        } else {
          color = Colors.material.green[500].hex;
          icon = <Icons.NavigationClose style={{ verticalAlign: 'middle' }} />;
          answers.push([{text: 'Correct is - ' + label}, color, icon]);
        }
      });
      if ((answers.length === correctAnswers.length) && choices[neededValue[0]]) {
        const color = Colors.material.red[800].hex;
        const icon = <Icons.NavigationClose style={{ verticalAlign: 'middle' }} />;
        for (let i = 0; i < neededValue.length; i++) {
          answers.push([{text: 'wrong - ' + choices[neededValue[i]]}, color, icon]);
        }
      }
      response = (
        <TaskFeedback
          leftIcon={<Icons.SocialPersonOutline />}
          answers={answers}
          created={created}
        />
      );
    } else {
      let color;
      let icon;
      if (correctAnswers.length < 1) {
        color = Colors.material.green[500].hex;
        icon = <Icons.NavigationCheck style={{ verticalAlign: 'middle' }} />;
      } else {
        color = Colors.material.red[800].hex;
        icon = <Icons.NavigationClose style={{ verticalAlign: 'middle' }} />;
      }
      response = (
        <TaskFeedback
          leftIcon={<Icons.SocialPersonOutline />}
          answers={[[{text: this.context.getIntlMessage('tasks.noAnswer')}, color]]}
          rightIcon={icon}
          created={created}
        />
      );
    }
    return (
      <div className={css.root}>
        {user && <span style={{ marginLeft: '10px' }}>{user.name}</span>}
        {response}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Task/CheckBoxTaskResult.js